/*----- Imports -----*/
import React 							from 'react'
import styled 						from 'styled-components'

/*----- Components -----*/
import MinNavButton from '../../button/MinNavButton'
import Device 			from '../../../commons/Device'

/*----- Styles -----*/
const StyledAsideMenu = styled.footer`
	background-color: #efefef;
	display: flex;
	flex-direction: column;
	justify-content: start;
	width: 100%;
	padding: 16px 32px;
	margin-top: 16px;
	.min-nav-button {
		align-items: start;
	}

	/*** Media queries ***/
	@media ${ Device.md } {
		flex-direction: row;
		justify-content: center;
		.min-nav-button {
			text-align: center;
		}
	}
`

/*----- Component -----*/
const AsideMenu = () => {
	return(
		<StyledAsideMenu className="aside-menu">
			<MinNavButton 
				content		  = "home"
				destination = "/"
			/>
			<MinNavButton 
				content		  = "productores"
				destination = "/producers"
			/>
			<MinNavButton 
				content		  = "nuestra casa"
				destination = "/our-home"
			/>
			<MinNavButton 
				content		  = "contacto"
				destination = "/contact"
			/>
		</StyledAsideMenu>
	)
}

export default AsideMenu